import { Link } from "react-router-dom";
import classes from "./Header.module.css";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import Menu from "../Menu/Menu";
import Cart from "../Cart/Cart";

const Header = () => {
  const logo = require("../../global/img/cyoung-logo.png");
  const navigate = useNavigate();
  const cartData = useSelector((state) => state.cart.items);

  const homeHandler = () => {
    navigate("/");
  };
  return (
    <nav className={classes.nav}>
      <ul className={classes.nav__list}>
        <li className={classes.nav__logo}>
          <img src={logo} alt="company logo" onClick={homeHandler}></img>
        </li>
        <li className={classes.nav__menu}>
          <Menu />
        </li>
        <li className={classes.nav__cart}>
          <Cart />
        </li>
      </ul>
    </nav>
  );
};

export default Header;
